import React from 'react'
import ZoomIcon from '../../../shared/ZoomIcon'
import styles from './ZoomButton.module.scss'

export const mapZoomTextIn = window?.drupalSettings?.widgets?.mapZoom?.textZoomIn ?? '' 

const ZoomButton = (props) => (
  <div className={styles.zoomButton} {...props}>
    <ZoomIcon />
    <span className='wording-agrandir-ab'>
      {mapZoomTextIn}
    </span>
  </div>
)

export default ZoomButton
